/* ============================================================
   TAO WEARING — Collection filters (new, update-safe).
   Auto-submits the filter form on change (filters + sort), and closes
   other open filter dropdowns when one opens.
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('[data-tao-filter-form]').forEach(function (form) {
    if (form._taoFilters) return;
    form._taoFilters = true;

    // submit on any filter / sort change
    form.addEventListener('change', function () { form.submit(); });

    // single-open dropdowns
    var details = form.querySelectorAll('.tao-filter');
    details.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) details.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  // close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.tao-filter[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });
})();
